export default __webpack_public_path__ + "static/media/pexels-liza-summer-6348123.69d01e99.png";